/** ROMs servidas via /api/roms (mesma origem que o portal — Cloudflare Pages + cookies). */

import { appUrl } from './appBase.js';

export function retroRomUrl(filename) {
  const name = String(filename || '').replace(/^.*[/\\]/, '');
  if (!name) return null;
  return appUrl(`roms/${encodeURIComponent(name)}`);
}

export function romApiUrl(filename) {
  const name = encodeURIComponent(String(filename || '').replace(/^.*[/\\]/, ''));
  if (typeof window === 'undefined') return `/api/roms/${name}`;
  return `${window.location.origin}/api/roms/${name}`;
}

export function romListApiUrl() {
  if (typeof window === 'undefined') return '/api/roms-list';
  return `${window.location.origin}/api/roms-list`;
}

/** Converte caminhos legados (/roms/x, /play/retro/roms/x) → URL estática retro para EmulatorJS. */
export function resolveRomUrl(urlOrPath, filename) {
  if (!urlOrPath) return filename ? retroRomUrl(filename) : null;
  if (urlOrPath instanceof File) return urlOrPath;

  const hint = filename || '';
  const s = String(urlOrPath);

  if (s.startsWith('/api/roms/')) {
    const name = decodeURIComponent(s.slice('/api/roms/'.length).split('?')[0]);
    return retroRomUrl(name);
  }

  const fromPath = (() => {
    const m = s.match(/\/roms\/([^?#]+)/i);
    if (m) return decodeURIComponent(m[1]);
    if (s.startsWith('roms/')) return decodeURIComponent(s.slice(5).split('?')[0]);
    if (!s.includes('/') && s.length) return s;
    return hint;
  })();

  if (fromPath) return retroRomUrl(fromPath);

  if (s.startsWith('http://') || s.startsWith('https://')) return s;
  if (typeof window !== 'undefined') {
    return `${window.location.origin}${s.startsWith('/') ? s : `/${s}`}`;
  }
  return s;
}

/** Descarrega a ROM no browser e entrega File ao EmulatorJS (fallback se /play/retro/roms/ falhar). */
export async function fetchRomForEmulator(urlOrFile, filename) {
  if (urlOrFile instanceof File) return urlOrFile;

  const name = (() => {
    if (filename) return String(filename).replace(/^.*[/\\]/, '');
    const s = String(urlOrFile || '');
    const m = s.match(/\/roms\/([^?#]+)/i);
    if (m) return decodeURIComponent(m[1]);
    if (s.startsWith('/api/roms/')) return decodeURIComponent(s.slice('/api/roms/'.length).split('?')[0]);
    return decodeURIComponent(s.split('/').pop()?.split('?')[0] || '');
  })();

  if (!name) throw new Error('URL da ROM em falta');

  const url = romApiUrl(name);

  const res = await fetch(url, { credentials: 'include', cache: 'no-store' });
  if (!res.ok) {
    throw new Error(`ROM inacessível (${res.status})`);
  }

  const blob = await res.blob();
  // Vault pode pedir .zip; o backend resolve para o ficheiro real (.nes, .nds, …)
  const resolved = res.headers.get('X-Rom-Resolved');
  const fileName =
    String(resolved || filename || name).replace(/^.*[/\\]/, '') || 'game.rom';

  return new File([blob], fileName, {
    type: blob.type || 'application/octet-stream',
  });
}
